'use client';

import { useFormContext } from 'react-hook-form';
import type { FieldValues, PathValue } from 'react-hook-form';

import type { FormTextFieldStoryblok } from '@utils/storyblok/storyblok';

import { FormField } from './Form';
import { InputForm } from './Input';

type FormTextFieldProps<T extends FieldValues> = Omit<FormTextFieldStoryblok, '_uid'> & {
  autoFocus?: boolean;
  defaultValue?: PathValue<T, any>;
  disabled?: boolean;
  errorMessage?: string;
  helperText?: string;
  loading?: boolean;
  type?: string;
};

export function FormTextField<T extends FieldValues>({
  defaultValue,
  disabled,
  errorMessage,
  helperText,
  label,
  name,
  required,
  placeholder,
}: FormTextFieldProps<T>) {
  const { control } = useFormContext<T>();

  return (
    <FormField
      control={control}
      defaultValue={defaultValue}
      disabled={disabled}
      name={name}
      render={({ field }) => {
        return (
          <InputForm
            errorMessage={errorMessage}
            field={field}
            helperText={helperText}
            id={name}
            label={label}
            placeholder={placeholder}
            required={required}
          />
        );
      }}
    />
  );
}
